<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiLoading from '../ui/Loading';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiLoading,
    },
    created() {
        sdk.pressengerControl.getCustomMenu().then(modules => {
            const module = modules.find(i => i.id === this.$route.params.id);
            if (!module) return;
            sdk.pressengerControl.getSessionId().then(sessiondId => {
                console.log(`${module.url}?sessionId=${sessiondId}&csrf=${sdk.getCsrf()}&moduleId=${module.id}&locale=${this.$i18n.locale}`);
                window.location = `${module.url}?sessionId=${sessiondId}&csrf=${sdk.getCsrf()}&moduleId=${module.id}&locale=${this.$i18n.locale}`;
            }).catch((e) => console.log(e));
        }).catch(() => null);
    },
}
</script>

<template>
    <ui-container class="CustomMod">
        <ui-loading />
    </ui-container>
</template>

<style lang="stylus"></style>
